import { toast } from "sonner";
import { Sentry } from "@/lib/sentry";

// The update hooks throw supabase's PostgrestError, which arrives as a plain
// object rather than an Error, so read `message` off anything that has one
// and report the failure so the next one names its cause (#821).
// Shared by the Events List and Pipeline views (#1429).
export function reportUpdateFailure(
  err: unknown,
  fallback: string,
  action: "status" | "outcome",
  eventId: string,
) {
  const e = err && typeof err === "object" ? (err as Record<string, unknown>) : {};
  const message = typeof e.message === "string" && e.message ? e.message : fallback;
  const code = typeof e.code === "string" ? e.code : undefined;
  // A constraint failure's details echo the whole row (client contact info).
  const details = code?.startsWith("23") ? "[redacted: row data]" : e.details;
  Sentry.captureException(err instanceof Error ? err : new Error(message), {
    tags: { action: `event_${action}_update` },
    fingerprint: ["event-update-failed", action, code ?? "no-code"],
    extra: {
      eventId,
      code,
      details,
      hint: e.hint,
      ...(err && typeof err === "object" ? {} : { raw: String(err) }),
    },
  });
  toast.error(message);
}
